import { render, staticRenderFns } from "./tipList.vue?vue&type=template&id=338781ba"
import script from "./tipList.vue?vue&type=script&lang=js"
export * from "./tipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports